import * as Rest from './../../Generated/RestClient';
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ControllerBase } from "./ControllerBase";
import { AccountSettingsPage } from "../Views/AccountSettingsPage";
import { MessageBox } from '../../Dialogs/MessageBox';

export class AccountSettingsController extends ControllerBase {
    private component: AccountSettingsPage;

    public render(params: SimpleMvc.QueryParams) {
        super.render(params);

        const element = React.createElement(AccountSettingsPage, {
            user: this.app.signedInUser,
            deleteAccount: _.bind(this.deleteAccount, this)
        });

        this.component = ReactDOM.render(element, this.pageContent);
    }

    private deleteAccount(user: Rest.AuthData): void {
        Rest.AccountClient.delete().then(() => {
            window.location.href = "/Identity/SignOut";
        }).fail(xhr => {
            const errorMessage = `Account deletion failed. ${xhr.status}.`;
            MessageBox.show(errorMessage);
        });
    }
}


// WEBPACK FOOTER //
// ./Client/v4/Controllers/AccountSettingsController.ts